import { Button } from '@/components'
import { RewardButtonWithState } from '@/components/molecules/rewards/RewardButton'
import React from 'react'
import { useTranslation } from 'react-i18next'
import type { PresentTypeBasedComponentsProps } from './presentTypeComponentType'

/**
 * PresentType 軸の/rewards/detail ページで使用されるコンポーネント
 * */
export const PresentType04PhotoFrameComponents = ({
  selectedType,
  presentType,
  checkCondition,
  isStock,
  presentItemList,
  isApplicationForm,
  inPeriod,
  onStartDownload,
  onStartDownloadWithLottery,
  onStartArCamera,
  onGoDirectToConfirm,
  onDecideUserPresentItem,
  buttonDisabled = false,
  userRewardState,
}: PresentTypeBasedComponentsProps) => {
  const { t } = useTranslation()
  if (presentType !== 'PhotoFrame') {
    return null
  }

  if (!isStock) {
    // - 特典リストを出す場合: すぐに「終了しました」を出す
    // - 特典リストを出さない場合: 特典を獲得していないければ、「終了しました」を出す。
    const skipSpecificCondition1 =
      selectedType === 3 && (userRewardState === 'RECEIVED' || userRewardState === 'EXCHANGED')
    const skipSpecificCondition2 =
      selectedType === 1 && (userRewardState === 'RECEIVED' || userRewardState === 'EXCHANGED')
    if ((skipSpecificCondition1 || skipSpecificCondition2) && !presentItemList) {
      // skipする
    } else {
      return (
        <RewardButtonWithState
          inPeriod={inPeriod}
          isStock={isStock}
          checkCondition={checkCondition}
          selectedType={selectedType}
          presentType={presentType}
          isApplicationForm={isApplicationForm}
        />
      )
    }
  }

  if (!inPeriod) {
    return (
      <RewardButtonWithState
        inPeriod={inPeriod}
        isStock={isStock}
        checkCondition={checkCondition}
        selectedType={selectedType}
        presentType={presentType}
        isApplicationForm={isApplicationForm}
      />
    )
  }
  return (
    <>
      {selectedType === 1 && (
        <>
          {userRewardState === 'CONDITION_MET' || userRewardState === 'CONDITION_NOT_MET' ? (
            <Button
              text={t('spot_detail.start_ar_camera', 'ARカメラ起動')}
              width="w-9/12"
              disabled={buttonDisabled || !checkCondition}
              onClick={() => {
                if (userRewardState === 'CONDITION_MET') {
                  onDecideUserPresentItem().then((userPresentId) => onGoDirectToConfirm({ userPresentId }))
                }
              }}
            />
          ) : (
            <Button
              text={t('spot_detail.start_ar_camera', 'ARカメラ起動')}
              width="w-9/12"
              disabled={buttonDisabled}
              onClick={() => {
                onGoDirectToConfirm({})
              }}
            />
          )}
        </>
      )}
      {selectedType === 2 && (
        <>
          <Button
            text={t('spot_detail.start_ar_camera', 'ARカメラ起動')}
            width="w-9/12"
            disabled={buttonDisabled || !checkCondition}
            onClick={onStartArCamera}
          />
        </>
      )}
      {selectedType === 3 && (
        <>
          {presentItemList ? (
            <>
              {userRewardState === 'CONDITION_MET' || userRewardState === 'CONDITION_NOT_MET' ? (
                <Button
                  text={t('reward_detail.lottery', '抽選する')}
                  width="w-9/12"
                  disabled={buttonDisabled || !checkCondition}
                  onClick={onStartDownloadWithLottery}
                />
              ) : (
                <Button
                  text={t('reward_detail.lottery', '抽選する')}
                  width="w-9/12"
                  disabled={buttonDisabled || !checkCondition}
                  onClick={onStartDownloadWithLottery}
                />
              )}
            </>
          ) : (
            <>
              {userRewardState === 'CONDITION_MET' || userRewardState === 'CONDITION_NOT_MET' ? (
                <Button
                  text={t('reward_detail.lottery', '抽選する')}
                  width="w-9/12"
                  disabled={buttonDisabled || !checkCondition}
                  onClick={onStartDownloadWithLottery}
                />
              ) : (
                <>
                  <Button
                    text={t('spot_detail.start_ar_camera', 'ARカメラ起動')}
                    width="w-9/12"
                    disabled={buttonDisabled}
                    onClick={() => {
                      onGoDirectToConfirm({})
                    }}
                  />
                </>
              )}
            </>
          )}
        </>
      )}
    </>
  )
}
